import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.facilities');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-project-facilities',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.facilities/view.scss */
:host {
  display: block;
}`],
})
export class ComponentProjectFacilitiesComponent implements OnInit {
    @Input() facilities: any[] = [];
    @Input() projectId: string = '';
    @Output() onAdd = new EventEmitter<void>();
    @Output() onDelete = new EventEmitter<any>();
    @Output() onDownload = new EventEmitter<any>();

    // 상세 모달
    public showDetailModal: boolean = false;
    public selectedFacility: any = null;
    public linkedDrawings: any[] = [];

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        // 부모 페이지에서 init/렌더를 담당
    }

    public openAddModal(): void {
        this.onAdd.emit();
    }

    public async deleteItem(event: Event, facility: any): Promise<void> {
        event.stopPropagation();
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 시설물을 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;
        this.onDelete.emit(facility);
    }

    public async openDetail(facility: any): Promise<void> {
        this.selectedFacility = facility;
        this.linkedDrawings = [];
        this.showDetailModal = true;
        this.ref.detectChanges();

        const { code, data } = await wiz.call("get_facility_detail", { id: facility.id });
        if (code === 200) {
            this.linkedDrawings = data.drawings || [];
            this.ref.detectChanges();
        }
    }

    public closeDetail(): void {
        this.showDetailModal = false;
        this.selectedFacility = null;
        this.linkedDrawings = [];
        this.ref.detectChanges();
    }

    public downloadDrawing(drawing: any): void {
        this.onDownload.emit(drawing);
    }

    public isPdf(drawing: any): boolean {
        const filename = drawing.filename || drawing.filepath || '';
        return filename.toLowerCase().endsWith('.pdf');
    }

    public formatFileSize(bytes: number): string {
        if (!bytes) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('ko-KR', { year: 'numeric', month: 'short', day: 'numeric' });
    }
}

export default ComponentProjectFacilitiesComponent;